import { useEffect, useState } from "react";
import { SAVE_FAVORITE } from "../api/constants";
const STORAGE_KEY = "favoriteProperties";


export default function useFavorites(propertyId, is_favorite) {
  const [isFavorite, setIsFavorite] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const favorites =
      JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    if (token) {
      setIsFavorite(is_favorite);
    } else {
      setIsFavorite(favorites.includes(propertyId));

    }

  }, [propertyId]);

  const toggleFavorite = () => {
    if (token) {
      saveFavorite()
    } else {
      const favorites =
        JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

      let updatedFavorites;

      if (favorites.includes(propertyId)) {
        updatedFavorites = favorites.filter(id => id !== propertyId);
      } else {
        updatedFavorites = [...favorites, propertyId];
      }

      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(updatedFavorites)
      );

      setIsFavorite(updatedFavorites.includes(propertyId));
    }

  };

  const saveFavorite= async () => {
      fetch(SAVE_FAVORITE, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          property_id: propertyId
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          console.log(data.data)
          if (data.data.saved) {
            setIsFavorite(true)
          } else {
           setIsFavorite(false)
          }
        })
        .catch((error) => {
          console.error("Error creating account:", error);
        });
    

  };

  return { isFavorite, toggleFavorite };
}


